export const SUBSCRIPTION_ACTIVATED =
  'Your subscription is now active. Invoices can be viewed any time in your Settings.';
export const PAYMENT_METHOD_UPDATED =
  'Your payment method has been updated. You can make further changes any time in your Settings.';
export const APP_CONNECT_SUCCESS =
  'Your app has been successfully connected. You can disconnect any time in your Settings.';
export const APP_CONNECT_FAIL =
  'Your app was not connected. Please try again in your Settings or contact support for assistance.';
